<div class="response-project-instructions">
  <div class="response-project-instructions-card">
    <div
      class="response-project-instructions-header"
      role="button"
      tabindex="0"
      (click)="collapsed = !collapsed"
      (keydown.enter)="collapsed = !collapsed"
      (keydown.space)="$event.preventDefault(); collapsed = !collapsed"
    >
      <i class="ph ph-clipboard-text response-project-instructions-icon" aria-hidden="true"></i>
      <span class="response-project-instructions-title">{{ 'tenders.responses.instructions.title' | translate }}</span>
      <span class="response-project-instructions-spacer"></span>
      <span class="response-project-instructions-optional">{{ 'tenders.responses.instructions.optional' | translate }}</span>
      <i
        class="ph ph-caret-down response-project-instructions-chevron"
        [class.response-project-instructions-chevron--collapsed]="collapsed"
        aria-hidden="true"
      ></i>
    </div>

    <div class="response-project-instructions-collapsible" [class.response-project-instructions-collapsible--collapsed]="collapsed">
      <div class="response-project-instructions-body" [class.response-project-instructions-body--disabled]="disabled">
        <p class="response-project-instructions-desc">{{ 'tenders.responses.instructions.desc' | translate }}</p>

        <button
          type="button"
          class="response-project-instructions-example-btn"
          [class.response-project-instructions-example-btn--open]="showExample"
          (click)="showExample = !showExample"
        >
          <i
            class="ph ph-caret-right response-project-instructions-example-caret"
            [class.response-project-instructions-example-caret--open]="showExample"
            aria-hidden="true"
          ></i>
          {{ 'tenders.responses.instructions.see-example' | translate }}
        </button>

        @if (showExample) {
          <div class="response-project-instructions-example-box">
            <p class="response-project-instructions-example-text">{{ 'tenders.responses.instructions.example-text' | translate }}</p>
          </div>
        }

        <textarea
          class="response-project-instructions-textarea"
          [style.border-color]="textareaBorderColor"
          [value]="value"
          (input)="onInputChange($any($event.target).value)"
          (focus)="onFocus()"
          (blur)="onBlur()"
          [placeholder]="'tenders.responses.instructions.placeholder' | translate"
        ></textarea>

        <div
          class="response-project-instructions-save"
          [class.response-project-instructions-save--visible]="statusSaved || statusConfirmed"
        >
          @if (statusConfirmed) {
            <span class="response-project-instructions-save-pill response-project-instructions-save-pill--grey">
              {{
                'tenders.responses.instructions.status-last-modified'
                  | translate: { time: (relativeTimeKey | translate: relativeTimeParams) }
              }}
            </span>
          } @else {
            <span class="response-project-instructions-save-pill response-project-instructions-save-pill--green">
              <i class="ph ph-check" aria-hidden="true"></i>
              {{ 'tenders.responses.instructions.status-saved' | translate }}
            </span>
          }
        </div>
      </div>
    </div>
  </div>
</div>
